<div class="customer-success-cash-in-modal">
    <div class="customer-operation-holder" id="pdfExport" #pdfExport>
        <div class="customer-operation-header">
            <div class="fw-500 customer-operation-header-amount">Total Amount</div>
            <div class="customer-operation-header-value mt-2">
                {{ transferResponse.amount | number }} <span class="currency-sub-text">{{ transferResponse.currency }}</span>
            </div>
            <div
                [ngClass]="{ 'customer-operation-header-success': isMoneySent, 'customer-operation-header-failed': !isMoneySent }"
                class="d-flex align-items-center mt-2"
            >
                <mat-icon svgIcon="{{ isMoneySent ? 'success' : 'failure' }}"></mat-icon>
                <div class="ms-1">{{ isMoneySent ? 'Money sent successfully' : errorDetails.title }}</div>
            </div>

            <div class="d-flex align-items-center justify-content-between customer-operation-details pt-5">
                <div
                    *ngIf="isMoneySent"
                    class="me-3 badge-gray text-truncate"
                    [title]="'Receiver will receive: ' + (transferResponse.amount | number) + ' ' + transferResponse.currency"
                >
                    Receiver will receive: {{ transferResponse.amount | number }} {{ transferResponse.currency }}
                </div>
                <div [ngClass]="{ 'middle-border': isMoneySent }" class="reference text-truncate" [title]="'Ref: ' + transferResponse.transaction_id">
                    Ref: {{ transferResponse.transaction_id }}
                </div>
                <div class="ps-3">{{ transferResponse.created | date : 'd MMM yyyy' }}</div>
            </div>
        </div>
        <div *ngIf="!isMoneySent" class="failure-reason d-flex flex-column w-100 align-items-start my-2 px-3">
            <div class="ms-1 failure-title">{{ errorDetails.title }}</div>
            <div class="failure-sub-title">{{ errorDetails.message }}</div>
        </div>
        <mat-card class="rounded-3 shadow-none overflow-hidden mb-3 p-0">
            <mat-card-content class="p-0 rounded-4">
                <div>
                    <div class="customer-operation-summary px-3 pt-3">
                        <div class="d-flex justify-content-between fw-500 mb-3">
                            <div>Amount</div>
                            <div>{{ transferResponse.amount | number }} {{ transferResponse.currency }}</div>
                        </div>
                        <div class="d-flex justify-content-between fw-500 my-3">
                            <div>Fee</div>
                            <div>{{ transferResponse.fee_amount | number }}</div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between fw-500 mt-2 p-3 final-summary">
                        <div class="lh-1">Total</div>
                        <div class="lh-1">{{ transferResponse.amount + transferResponse.fee_amount | number }} {{ transferResponse.currency }}</div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card class="rounded-3 shadow-none overflow-hidden mb-3 p-0">
            <mat-card-content class="p-0 rounded-4">
                <div>
                    <div class="d-flex justify-content-between fw-500 p-3 final-summary">
                        <div class="lh-1">Sender</div>
                        <div class="lh-1"></div>
                    </div>
                    <div class="customer-operation-summary px-3 pt-3">
                        <div class="d-flex align-items-center justify-content-between fw-500 mb-3">
                            <div class="d-flex">
                                <!-- <img [src]="'../../../../assets/male-avatar.png'" alt="customer-image" class="customer-img rounded-circle" height="32" width="32" /> -->
                                <div class="ps-2">
                                    <h6 class="customer-title">{{ userInfo.first_name + ' ' + userInfo.last_name }}</h6>
                                    <div class="customer-info">{{ userInfo.mobile }}</div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <div>Wallet:</div>
                                <div class="px-2 d-flex align-items-center">
                                    <img
                                        [src]="'/assets/currency-flags/' + transferResponse.currency + '-flag.svg'"
                                        [alt]="transferResponse.currency"
                                        class="currency-img rounded-circle me-1"
                                    />
                                    <div class="ps-1">{{ transferResponse.currency }}</div>
                                </div>
                                <div>{{ '*'.repeat(7) + transferResponse.sender_account_id.slice(-4) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card class="rounded-3 shadow-none overflow-hidden mb-3 p-0">
            <mat-card-content class="p-0 rounded-4">
                <div>
                    <div class="d-flex justify-content-between fw-500 p-3 final-summary">
                        <div class="lh-1">Receiver</div>
                        <div class="lh-1"></div>
                    </div>
                    <div class="customer-operation-summary px-3 pt-3">
                        <div class="d-flex align-items-center justify-content-between fw-500 mb-3">
                            <div class="d-flex">
                                <!-- <img [src]="'../../../../assets/male-avatar.png'" alt="customer-image" class="customer-img rounded-circle" height="32" width="32" /> -->
                                <div class="ps-2">
                                    <h6 class="customer-title">
                                        {{ maskedRecipientName }}
                                    </h6>
                                    <div class="customer-info">{{ recipientInfo.mobile }}</div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <div>Wallet:</div>
                                <div class="px-2 d-flex align-items-center">
                                    <img
                                        [src]="'/assets/currency-flags/' + transferResponse.currency + '-flag.svg'"
                                        [alt]="transferResponse.currency"
                                        class="currency-img rounded-circle me-1"
                                    />
                                    <div class="ps-1">{{ transferResponse.currency }}</div>
                                </div>
                                <div>{{ '*'.repeat(7) + transferResponse.recipient_account_id.slice(-4) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="customer-operation-actions d-flex justify-content-start align-items-center">
        <button
            *ngIf="isMoneySent"
            [disableRipple]="true"
            class="rounded-pill text-white customer-operation-btn btn me-2"
            color="primary"
            mat-flat-button
            (click)="handleDownloadPdf()"
        >
            <span>Download receipt</span>
        </button>
        <button
            *ngIf="!isMoneySent"
            [disableRipple]="true"
            class="rounded-pill text-white customer-operation-btn btn me-2"
            color="primary"
            mat-flat-button
            (click)="retryFundsTransfer()"
        >
            <span>Retry</span>
        </button>
        <button (click)="dialogRef.close()" [disableRipple]="true" class="rounded-pill text-white customer-operation-cancel-btn btn" color="primary" mat-flat-button>
            <span>{{ isMoneySent ? 'Done' : 'Cancel' }}</span>
        </button>
    </div>
</div>
